import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8bca58c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users p-20 flex column gap-12" }
const _hoisted_2 = { class: "timeline-list flex column overflow-hidden gap-20 overflow-hidden" }
const _hoisted_3 = { class: "ops flex align-center" }
const _hoisted_4 = { class: "timeline flex-1 overflow-overlay flex column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text nowrap-text" }, "年份", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text nowrap-text" }, "說明", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space flex-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "form full-page flex column p-20",
      ref: "form",
      model: _ctx.form,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "公司 Slogan" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.slogan,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.slogan) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "關於 TOP TEAM" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.introduction,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.introduction) = $event)),
              type: "textarea",
              autosize: { minRows: 2, maxRows: 4 }
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "公司簡介" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.description) = $event)),
              type: "textarea",
              autosize: { minRows: 2, maxRows: 4 }
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "通知用 Email" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.contactEmail,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.contactEmail) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "flex-1 flex align-stretch overflow-hidden",
          label: "大事記設定"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.addTimeline
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增項目")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.sortTimeline
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("照年份排序")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeline, (data, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "timeline-item flex align-center gap-8 p-8",
                    key: idx
                  }, [
                    _createVNode(_component_el_popconfirm, {
                      "confirm-button-text": "確認",
                      "cancel-button-text": "取消",
                      title: "確認要刪除該項大事記？",
                      onConfirm: ($event: any) => (_ctx.deleteTimeline(idx))
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "mini",
                          icon: _ctx.Delete
                        }, null, 8, ["icon"])
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"]),
                    _hoisted_5,
                    _createVNode(_component_el_input, {
                      class: "year-input",
                      modelValue: data.year,
                      "onUpdate:modelValue": ($event: any) => ((data.year) = $event),
                      type: "number",
                      min: "1900",
                      max: "2100"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _hoisted_6,
                    _createVNode(_component_el_input, {
                      class: "content-input",
                      type: "textarea",
                      modelValue: data.content,
                      "onUpdate:modelValue": ($event: any) => ((data.content) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _hoisted_7,
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.save
            }, {
              default: _withCtx(() => [
                _createTextVNode("儲存")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.reset }, {
              default: _withCtx(() => [
                _createTextVNode("重設")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}